import { useState } from "react"
import { Routes, Route } from "react-router-dom"
import PrivateOutlet from "./utils/PrivateOutlet"

import './App.css';

import LandingPage from "./components/LandingPage"
import Register from "./components/forms/Register"
import Forgot from "./components/forms/Forgot"

import Home from "./components/Home"
import AboutUs from "./components/AboutUs"
import ContactUs from "./components/ContactUs"

import Dining from "./components/Dining"
import Catering from "./components/Catering"

function App() {
  const [ user, setUser ] = useState(null)  

  return (
    <div className="App">
      <Routes>
        <Route exact path="/" element={<LandingPage />} />
        
        <Route path="/home" element={<Home />} />
        <Route path="/about" element={<AboutUs />} />
        <Route path="/contact" element={<ContactUs />} />
        <Route path="/dining" element={<Dining />} />
        <Route path="/catering" element={<Catering />} />

        <Route path="/register" element={<Register setUser={setUser} />} />
        <Route path="/forgot" element={<Forgot setUser={setUser} />} />

        <Route path="/order/*" element={<PrivateOutlet user={user} />} />
      </Routes>
    </div>
  );
}

export default App;
